import React from 'react'
import { useTranslation } from 'react-i18next'

const ExamFooter = (props) => {
  const { index, totalQuestion, examType, courseName, totalWrongQ, totalCorrectQ, totalSkipQ, direction, footerNav, templateVariant } = props;
  const { t } = useTranslation();

  return (
    <footer className={`footer m-0 exam-footer ${templateVariant === 'template1' ? 'exam-template1-footer' : 'p-3'}`} style={{ boxShadow: "inset 0px 0.1px 5px 0px #38414a26" }}>
      <div className="container-fluid">
        {footerNav ?
          <div className="exam-footer-nav-row">
            {footerNav}
          </div>
          : ''}

        <div className={`exam-footer-info-row ${templateVariant === 'template1' ? 'exam-template1-footer-info' : 'row g-2 align-items-center text-primary'}`}>
          <div className={templateVariant === 'template1' ? 'exam-footer-course' : 'col-12 col-md-6 fs-6 fs-md-5'}>
            <i className={`ri-book-line align-bottom ${direction === 'ltr' ? 'me-2' : 'ms-2'}`}> </i>
            {t('Theory Driving')} {examType == 1 ? t('Exam') : t('Practice')} {t('for')} {courseName}
          </div>

          {examType == 2 ?
            <div className={templateVariant === 'template1' ? 'exam-footer-stats' : 'col-12 col-md-6 d-flex justify-content-md-end exam-footer-stats'}>
              <button className="btn btn-danger waves-effect waves-light">WA : {totalWrongQ}</button>
              <button className="btn btn-primary waves-effect waves-light">CA : {totalCorrectQ}</button>
              <button className="btn btn-info waves-effect waves-light">SA : {totalSkipQ}</button>
            </div>
            : ''}

          <div className={templateVariant === 'template1' ? 'exam-footer-progress' : 'col-12 col-md-6 d-flex justify-content-md-end fs-6 fs-md-5'}>
            <span>{t('Question')} {index + 1} {t('out of')} {totalQuestion}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default ExamFooter
